// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".partners>>>svg{max-width:70%}.partners-slider .swiper-slide{transition:.6s ease!important}.catalogue-head{padding-bottom:49px}.catalogue-head .titles .catalogue-ttl{margin-bottom:12px}.catalogue-head .titles .catalogue-teaser{color:hsla(0,0%,85.5%,.8352941176470589)}@media (max-width:767px){.catalogue-head{padding-bottom:43px}.catalogue-head .titles .catalogue-ttl,.catalogue-ttl.font-38{font-size:24px}.catalogue-head .titles .catalogue-teaser{font-size:16px}}", ""]);
// Exports
module.exports = exports;
